module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Regulamin")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Treść regulaminu",
      "error": _vm.errors['regulation.content']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "25"
    },
    model: {
      value: (_vm.regulation.content),
      callback: function($$v) {
        _vm.regulation.content = $$v
      },
      expression: "regulation.content"
    }
  })], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-743fa66a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Regulations.vue
// module id = 459
// module chunks = 1